import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import { ContentfulIcon } from '@/components/icon';
import { Text } from '@/components/text';

import type { PlanSchema } from '@energy-retailer/schema';

type ProductPlanFeaturesProps = Pick<PlanSchema, 'product'>;

const ProductPlanCardFeatures = ({ product }: ProductPlanFeaturesProps) => {
  const { features } = product;

  if (!features.length) {
    return null;
  }

  return (
    <div className="hidden lg:block">
      <div className="grid grid-cols-12 gap-b">
        {features.map((feature) => (
          <div
            key={feature.id}
            className={twMerge(
              clsx('col-span-12 flex items-center gap-b', {
                'col-span-6': features.length > 1,
              })
            )}
          >
            <ContentfulIcon
              id={feature.icon}
              className="h-icon w-icon min-w-icon text-product-plan-card-accent md:h-icon-xs md:w-icon-xs md:min-w-icon-xs"
            />
            <div>
              <Text variant="body2">{feature.text}</Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { ProductPlanCardFeatures };
